import { listenerMiddleware } from "../../../store/middleware";
import { setOpenModal } from "../../ControlPanel/store/controlPanelSlice";
import { RECIEVE_FOCUS_ALERT } from "./ProductivitySessionSlice";


listenerMiddleware.startListening({
    actionCreator: RECIEVE_FOCUS_ALERT,
    effect: async (action, listenerApi) => {
        listenerApi.dispatch(setOpenModal("user_in_focus"));
    }
})